<div class="main">
    <div class="dx-field-title" translate>remotePlatforms.pageTitle</div>
    <div class="dx-field tabs">
        <dx-button [width]="200" [text]="'_commons.ftp' | translate" [ngClass]="{ 'active': activeTab === 'ftp' }"
                   (onClick)="activeTab = 'ftp'"></dx-button>
        <dx-button [width]="200" [text]="'_commons.http' | translate" [ngClass]="{ 'active': activeTab === 'http' }"
                   (onClick)="activeTab = 'http'"></dx-button>
        <dx-button [width]="200" [text]="'_commons.sftp' | translate" [ngClass]="{ 'active': activeTab === 'sftp' }"
                   (onClick)="activeTab = 'sftp'"></dx-button>
        <dx-button [width]="200" [text]="'_commons.sharepoint' | translate" [ngClass]="{ 'active': activeTab === 'sharepoint' }"
                   (onClick)="activeTab = 'sharepoint'"></dx-button>
        <dx-button [width]="200" [text]="'_commons.azureStorage' | translate" [ngClass]="{ 'active': activeTab === 'azureStorage' }"
                   (onClick)="activeTab = 'azureStorage'"></dx-button>
    </div>
    <div class="main-tabs" style="height:calc(100vh - 200px)">
        <ng-container [ngSwitch]="activeTab">
            <!-- FTP -->
            <ng-container *ngSwitchCase="'ftp'">
                <dx-data-grid #ftpGrid
                              height="100%"
                              keyExpr="id"
                              [columnAutoWidth]="true"
                              [dataSource]="ftpDataSource"
                              [errorRowEnabled]="false"
                              [focusedRowEnabled]="true"
                              [hoverStateEnabled]="true"
                              [wordWrapEnabled]="true"
                              (onContextMenuPreparing)="onContextMenuPreparing($event, 'ftp')"
                              (onRowDblClick)="displayRemotePlatform($event, 'ftp')"
                              (onRowPrepared)="onRowPrepared($event)">
                    <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                    <dxo-paging [enabled]="false"></dxo-paging>
                    <dxo-summary>
                        <dxi-total-item column="name" [displayFormat]="'remotePlatforms.lblPlatformsCount' | translate" summaryType="count"></dxi-total-item>
                    </dxo-summary>
                    <dxo-toolbar>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="newRemotePlatform('ftp')"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="reloadDataSource()"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item name="searchPanel"></dxi-item>
                    </dxo-toolbar>

                    <dxi-column dataField="name" [caption]="'remotePlatforms.lblName' | translate"></dxi-column>
                    <dxi-column dataField="server" [caption]="'remotePlatforms.lblServer' | translate"></dxi-column>
                    <dxi-column dataField="port" [caption]="'remotePlatforms.lblPort' | translate"></dxi-column>
                    <dxi-column dataField="account" [caption]="'remotePlatforms.lblAccount' | translate"></dxi-column>
                    <dxi-column dataField="ipFiltering" [caption]="'remotePlatforms.lblIpFiltering' | translate" [width]="140"></dxi-column>
                    <dxi-column dataField="isDisabled" [caption]="'remotePlatforms.lblDisabled' | translate" [width]="140"></dxi-column>
                </dx-data-grid>
            </ng-container>
            <!-- HTTP -->
            <ng-container *ngSwitchCase="'http'">
                <dx-data-grid #httpGrid
                              height="100%"
                              keyExpr="id"
                              [columnAutoWidth]="true"
                              [dataSource]="httpDataSource"
                              [errorRowEnabled]="false"
                              [focusedRowEnabled]="true"
                              [hoverStateEnabled]="true"
                              [wordWrapEnabled]="true"
                              (onContextMenuPreparing)="onContextMenuPreparing($event, 'http')"
                              (onRowDblClick)="displayRemotePlatform($event, 'http')"
                              (onRowPrepared)="onRowPrepared($event)">
                    <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                    <dxo-paging [enabled]="false"></dxo-paging>
                    <dxo-summary>
                        <dxi-total-item column="name" [displayFormat]="'remotePlatforms.lblPlatformsCount' | translate" summaryType="count"></dxi-total-item>
                    </dxo-summary>
                    <dxo-toolbar>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="newRemotePlatform('http')"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="reloadDataSource()"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item name="searchPanel"></dxi-item>
                    </dxo-toolbar>

                    <dxi-column dataField="name" [caption]="'remotePlatforms.lblName' | translate"></dxi-column>
                    <dxi-column dataField="url" [caption]="'remotePlatforms.lblUrl' | translate"></dxi-column>
                    <dxi-column dataField="account" [caption]="'remotePlatforms.lblAccount' | translate"></dxi-column>
                    <dxi-column dataField="ipFiltering" [caption]="'remotePlatforms.lblIpFiltering' | translate" [width]="140"></dxi-column>
                    <dxi-column dataField="isDisabled" [caption]="'remotePlatforms.lblDisabled' | translate" [width]="140"></dxi-column>
                </dx-data-grid>
            </ng-container>
            <!-- SFTP -->
            <ng-container *ngSwitchCase="'sftp'">
                <dx-data-grid #sftpGrid
                              height="100%"
                              keyExpr="id"
                              [dataSource]="sftpDataSource"
                              [columnAutoWidth]="true"
                              [errorRowEnabled]="false"
                              [focusedRowEnabled]="true"
                              [hoverStateEnabled]="true"
                              [wordWrapEnabled]="true"
                              (onContextMenuPreparing)="onContextMenuPreparing($event, 'sftp')"
                              (onRowDblClick)="displayRemotePlatform($event, 'sftp')"
                              (onRowPrepared)="onRowPrepared($event)">
                    <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                    <dxo-paging [enabled]="false"></dxo-paging>
                    <dxo-summary>
                        <dxi-total-item column="name" [displayFormat]="'remotePlatforms.lblPlatformsCount' | translate" summaryType="count"></dxi-total-item>
                    </dxo-summary>
                    <dxo-toolbar>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="newRemotePlatform('sftp')"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="reloadDataSource()"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item name="searchPanel"></dxi-item>
                    </dxo-toolbar>

                    <dxi-column dataField="name" [caption]="'remotePlatforms.lblName' | translate"></dxi-column>
                    <dxi-column dataField="server" [caption]="'remotePlatforms.lblServer' | translate"></dxi-column>
                    <dxi-column dataField="port" [caption]="'remotePlatforms.lblPort' | translate"></dxi-column>
                    <dxi-column dataField="account" [caption]="'remotePlatforms.lblAccount' | translate"></dxi-column>
                    <dxi-column dataField="authenticationMode" [calculateCellValue]="getSftpAuthenticationMode" [caption]="'remotePlatforms.lblAuthentication' | translate"></dxi-column>
                    <dxi-column dataField="useIpWorksEngine" [caption]="'remotePlatforms.lblUseIpWorksEngine' | translate"></dxi-column>
                    <dxi-column dataField="ipFiltering" [caption]="'remotePlatforms.lblIpFiltering' | translate" [width]="140"></dxi-column>
                    <dxi-column dataField="isDisabled" [caption]="'remotePlatforms.lblDisabled' | translate" [width]="140"></dxi-column>
                </dx-data-grid>
            </ng-container>
            <!-- SHAREPOINT -->
            <ng-container *ngSwitchCase="'sharepoint'">
                <dx-data-grid #spGrid
                              height="100%"
                              keyExpr="id"
                              [columnAutoWidth]="true"
                              [dataSource]="spDataSource"
                              [errorRowEnabled]="false"
                              [focusedRowEnabled]="true"
                              [hoverStateEnabled]="true"
                              [wordWrapEnabled]="true"
                              (onContextMenuPreparing)="onContextMenuPreparing($event, 'sp')"
                              (onRowDblClick)="displayRemotePlatform($event, 'sp')"
                              (onRowPrepared)="onRowPrepared($event)">
                    <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                    <dxo-paging [enabled]="false"></dxo-paging>
                    <dxo-summary>
                        <dxi-total-item column="name" [displayFormat]="'remotePlatforms.lblPlatformsCount' | translate" summaryType="count"></dxi-total-item>
                    </dxo-summary>
                    <dxo-toolbar>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="newRemotePlatform('sp')"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="reloadDataSource()"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item name="searchPanel"></dxi-item>
                    </dxo-toolbar>

                    <dxi-column dataField="name" [caption]="'remotePlatforms.lblName' | translate"></dxi-column>
                    <dxi-column dataField="platform" [calculateCellValue]="getSharePointPlatform" [caption]="'remotePlatforms.lblPlatform' | translate"></dxi-column>
                    <dxi-column dataField="siteURL" [caption]="'remotePlatforms.lblSiteURL' | translate"></dxi-column>
                    <dxi-column dataField="authenticationMode" [calculateCellValue]="getSharePointAuthenticationMode" [caption]="'remotePlatforms.lblAuthentication' | translate"></dxi-column>
                    <dxi-column dataField="account" [caption]="'remotePlatforms.lblAccount' | translate"></dxi-column>
                    <dxi-column dataField="ipFiltering" [caption]="'remotePlatforms.lblIpFiltering' | translate" [width]="140"></dxi-column>
                    <dxi-column dataField="isDisabled" [caption]="'remotePlatforms.lblDisabled' | translate" [width]="140"></dxi-column>
                </dx-data-grid>
            </ng-container>
            <!-- AZURE STORAGE -->
            <ng-container *ngSwitchCase="'azureStorage'">
                <dx-data-grid #azureStorageGrid
                              height="100%"
                              keyExpr="id"
                              [columnAutoWidth]="true"
                              [dataSource]="azureStorageDataSource"
                              [errorRowEnabled]="false"
                              [focusedRowEnabled]="true"
                              [hoverStateEnabled]="true"
                              [wordWrapEnabled]="true"
                              (onContextMenuPreparing)="onContextMenuPreparing($event, 'azureStorage')"
                              (onRowDblClick)="displayRemotePlatform($event, 'azureStorage')"
                              (onRowPrepared)="onRowPrepared($event)">
                    <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
                    <dxo-header-filter [visible]="true"></dxo-header-filter>
                    <dxo-paging [enabled]="false"></dxo-paging>
                    <dxo-summary>
                        <dxi-total-item column="name" [displayFormat]="'remotePlatforms.lblPlatformsCount' | translate" summaryType="count"></dxi-total-item>
                    </dxo-summary>
                    <dxo-toolbar>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="newRemotePlatform('azureStorage')"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="reloadDataSource()"></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item name="searchPanel"></dxi-item>
                    </dxo-toolbar>

                    <dxi-column dataField="name" [caption]="'remotePlatforms.lblName' | translate"></dxi-column>
                    <dxi-column dataField="accountName" [caption]="'remotePlatforms.lblAccountName' | translate"></dxi-column>
                    <dxi-column dataField="serviceType" [calculateCellValue]="getAzureStorageService" [caption]="'remotePlatforms.lblServiceType' | translate"></dxi-column>
                    <dxi-column dataField="authenticationMode" [calculateCellValue]="getAzureStorageAuthenticationMode" [caption]="'remotePlatforms.lblAuthentication' | translate"></dxi-column>
                    <dxi-column dataField="ipFiltering" [caption]="'remotePlatforms.lblIpFiltering' | translate" [width]="140"></dxi-column>
                    <dxi-column dataField="isDisabled" [caption]="'remotePlatforms.lblDisabled' | translate" [width]="140"></dxi-column>
                </dx-data-grid>
            </ng-container>
        </ng-container>
    </div>
</div>

<!--Azure Storage Popup-->
<app-remote-platform-azure-storage #azureStoragePopup (onClose)="remotePlatformPopupClosed($event)"></app-remote-platform-azure-storage>

<!--FTP Popup-->
<app-remote-platform-ftp #ftpPopup (onClose)="remotePlatformPopupClosed($event)"></app-remote-platform-ftp>

<!--HTTP Popup-->
<app-remote-platform-http #httpPopup (onClose)="remotePlatformPopupClosed($event)"></app-remote-platform-http>

<!--SFTP Popup-->
<app-remote-platform-sftp #sftpPopup (onClose)="remotePlatformPopupClosed($event)"></app-remote-platform-sftp>

<!--SharePoint Popup-->
<app-remote-platform-sharepoint #sharepointPopup (onClose)="remotePlatformPopupClosed($event)"></app-remote-platform-sharepoint>

<!-- Check Connection popup -->
<app-local-agent-check-connection #checkConnectionPopup></app-local-agent-check-connection>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
